import { render, staticRenderFns } from "./extraButtons.vue?vue&type=template&id=0e66f1f7"
import script from "./extraButtons.vue?vue&type=script&lang=js"
export * from "./extraButtons.vue?vue&type=script&lang=js"
import style0 from "./extraButtons.vue?vue&type=style&index=0&id=0e66f1f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports